import { Button, Card } from '@/design-system';

import { dashboardCopy } from '../copy';

export interface FieldStartCardProps {
    /** Werkt deze persoon op locatie? Dan gaat de knop naar Mijn dag, anders naar Keuringen. */
    field: boolean;
    onOpen: () => void;
}

/**
 * De lege staat voor wie geen keuringen aanmaakt: een inspecteur bij een bedrijf
 * waar nog niets op zijn naam staat. Geen nullen, maar wat er gaat gebeuren en
 * waar hij dan moet zijn.
 */
export function FieldStartCard({ field, onOpen }: FieldStartCardProps) {
    return (
        <Card padding="lg" as="section" aria-labelledby="field-start-title">
            <h2
                id="field-start-title"
                className="m-0 font-[family-name:var(--font-display)] text-[19px] leading-[1.25] font-semibold tracking-[-0.01em] text-[var(--text-primary)]"
            >
                {dashboardCopy.fieldEmptyTitle}
            </h2>
            <p className="m-0 mt-2 max-w-[62ch] text-[14px] leading-[1.5] text-[var(--text-secondary)]">
                {dashboardCopy.fieldEmptyBody}
            </p>
            <Button variant="primary" size="sm" className="mt-[14px]" onClick={onOpen}>
                {field ? dashboardCopy.fieldEmptyAction : dashboardCopy.fieldEmptyActionOffice}
            </Button>
        </Card>
    );
}
